<!--

A callout for displaying an announcement

-->

<template>
	<div>
		<div class="container mia-announcementContainer">
			<responsive-image from="@theme/Icon_New.svg" class="mia-newIcon" />
			<div class="mia-announcementText">
				<div v-if="includeLink">
					<a :href="$tr('miaprepannouncement.link')">
						<span v-tr="'miaprepannouncement.linktext'" />
					</a>
					<span v-tr="'miaprepannouncement.linktextremainder'" />
				</div>
				<span v-else v-tr="'miaprepannouncement.plaintext'" />
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { Vue, Component, Prop, toNative } from "vue-facing-decorator";
import ResponsiveImage from "@/Control/Vue/ResponsiveImage";

@Component({
	components: {
		ResponsiveImage,
	},
})
export class MiaPrepAnnouncement extends Vue {
	@Prop({ type: Boolean, required: true }) includeLink!: boolean;
}

export default toNative(MiaPrepAnnouncement);
</script>
<style lang="scss">
.mia-MiaPrepAnnouncement {
	background: linear-gradient(90deg, theme.$mia-color-themeMain 0%, theme.$mia-color-themeMain-dark 100%);
	color: theme.$mia-color-themeMain-font;
	padding: theme.$mia-padding-panel 0;

	.mia-announcementContainer {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.mia-newIcon {
		flex-shrink: 0;
		margin: 0 theme.$mia-icon-margin;
		display: flex;
		justify-content: center;
		width: theme.$mia-icon-size-huge;
	}

	.mia-announcementText {
		font-size: theme.$font-size-h3;

		a {
			color: theme.$mia-color-themeMain-font;
			text-decoration: underline;
		}
	}

	@media (max-width: theme.$screen-sm-max) {
		.mia-announcementText {
			font-size: theme.$font-size-h4;
		}
	}
}
</style>
